module.exports = require("./uz.js");